<template>
  <div class="FeedMenu">
    <ul
      v-for="section in sections"
      :key="section.key"
      :class="{ 'feed-menu-pages': !section.title }"
    >
      <li
        v-if="section.title"
        class="feed-menu-heading"
      >
        <router-link
          v-if="section.manage"
          class="feed-menu-heading-link"
          :to="section.manage"
          :aria-label="$t('nav.manage_group', { group: $t(section.title) })"
          :title="$t('nav.manage_group', { group: $t(section.title) })"
        >
          <span>{{ $t(section.title) }}</span>
          <FAIcon icon="chevron-right" />
        </router-link>
        <span v-else>{{ $t(section.title) }}</span>
      </li>
      <NavigationEntry
        v-for="item in section.items"
        :key="item.name"
        :item="item"
        :pinnable="pinnable"
      />
    </ul>
    <ul
      v-if="settings"
      class="feed-menu-settings"
    >
      <li class="menu-item">
        <TimelineSettingsMenu labelled />
      </li>
    </ul>
  </div>
</template>

<script src="./feed_menu.js"></script>

<style lang="scss">
.FeedMenu {
  ul {
    list-style: none;
    margin: 0;
    padding: 0.25em;
  }

  ul + ul {
    padding-top: 0;
  }

  .feed-menu-heading {
    display: flex;
    padding: 0.5em 0.75em 0.15em;
    font-size: var(--fs-sm);
    color: var(--textFaint);
  }

  /* the heading as the link to the page that manages the group: "Lists ›" */
  .feed-menu-heading-link {
    display: inline-flex;
    align-items: center;
    gap: 0.3em;
    color: inherit;
    border-radius: var(--r-item);

    &:hover,
    &:focus-visible {
      color: var(--link);
    }

    svg {
      height: 0.8em;
    }
  }

  .menu-item {
    border-radius: var(--r-item);
  }

  /* the rows to the pages of the empty groups, and the settings */
  .feed-menu-pages,
  .feed-menu-settings {
    border-top: 1px solid var(--border);
  }

  ul.feed-menu-pages {
    padding-top: 0.25em;
  }

  /* laid out like the NavigationEntry rows above it */
  .feed-menu-settings {
    .popover-wrapper,
    .popover-trigger-button {
      display: flex;
      align-items: center;
      width: 100%;
    }

    .popover-trigger-button {
      padding: 0.4em 0.5em;
      line-height: 2.5em;
      text-align: start;
    }

    .menu-icon {
      width: 2.5em;
      margin-right: 0.5em;
    }
  }
}
</style>
